import { Button } from '../../components/Button/Button';
import QbLogoFullName from '../../components/Icons/QbLogoFullName';

type Props = {
  reset?: () => void;
};

const ErrorFallbackPage = ({ reset }: Props) => {
  return (
    <div className="flex h-full flex-col overflow-y-auto">
      <header className="flex flex-row items-center justify-between pl-3 pr-4 mt-3 mb-7 pb-3">
        <a href="/">
          <QbLogoFullName />
        </a>
      </header>
      <main className="flex flex-1 flex-col items-center justify-start px-5 pb-14 pt-1">
        <h1 className="mb-3">Absturz - Ein Fehler ist aufgetreten!</h1>
        <div className="my-5 space-y-4 sm:my-10">
          <p>
            Dieser Fehler wurde direkt an die Saufkommission gemeldet und wir
            werden mit Hochdruck - und Hochprozentigem - daran arbeiten.
          </p>
        </div>
        <div className="flex flex-1 flex-col items-center justify-end gap-y-4 pt-4">
          <Button type="button" onClick={() => (window.location.href = '/')}>
            Zur Startseite
          </Button>
          {!!reset && (
            <Button type="button" onClick={reset}>
              Nochmal versuchen
            </Button>
          )}
        </div>
      </main>
    </div>
  );
};

export default ErrorFallbackPage;
